import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import AlumniHeader from "../Alumni/AlumniHeader";
export default function CreatePortfolio() {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState("");
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    profession: '',
    about: '',
    education: '',
    address: '',
    number: '',
    experiences: [{ companyName: '', designation: '', startDate: null, endDate: null, experienceDescription: '', isPresent: false }],
    projects: [{ projectName: '', description: '' }],
    skills: '',
  });

  useEffect(() => {
    const userEmail = localStorage.getItem('email');
    if (userEmail) {
      setFormData(prevState => ({ ...prevState, email: userEmail }));
    }
  }, []);
  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    if (storedRole) {
      const parsedRole = JSON.parse(storedRole);
      setUserRole(parsedRole.role);
    }
  }, []);
  const handleChange = (e, index, type) => {
    const { name, value } = e.target;
    const newData = [...formData[type]];
    newData[index][name] = value;
    setFormData({ ...formData, [type]: newData });
  };

  const handleDateChange = (date, index, type, dateType) => {
    const newData = [...formData[type]];
    newData[index][dateType] = date;
    setFormData({ ...formData, [type]: newData });
  };

  const togglePresent = (index) => {
    const newData = [...formData.experiences];
    newData[index].isPresent = !newData[index].isPresent;
    setFormData({ ...formData, experiences: newData });
  };

  const addMore = (type) => {
    setFormData({
      ...formData,
      [type]: [...formData[type], type === 'experiences' ? { companyName: '', designation: '', startDate: null, endDate: null, experienceDescription: '', isPresent: false } : { projectName: '', description: '' }],
    });
  };

  const removeItem = (index, type) => {
    const newData = [...formData[type]];
    newData.splice(index, 1);
    setFormData({ ...formData, [type]: newData });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formattedData = {
        ...formData,
        experiences: formData.experiences.map(exp => ({
          ...exp,
          startDate: exp.startDate ? exp.startDate.toISOString().split('T')[0] : null,
          endDate: exp.isPresent ? null : (exp.endDate ? exp.endDate.toISOString().split('T')[0] : null),
        })),
        projects: formData.projects.map(project => ({ ...project })),
      };

      const response = await fetch('https://alumni-portal-backend-vccv.onrender.com/auth/CreatePortfolio', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(formattedData),
      });

      const responseData = await response.json();

      if (response.ok) {
        alert(JSON.stringify(responseData.message));
        navigate('/Portfolio');
      } else {
        throw new Error(responseData.message || 'Failed to create portfolio');
      }
    } catch (error) {
      console.error('Error creating portfolio:');
      alert('Error creating portfolio. Please try again later.');
    }
  };

  return (
    
    <div className="bg-white font-poppins">
           {userRole === "alumni" ? (
        <AlumniHeader />
      ) : userRole === "student" ? (
        <Header />
      ) : null}
    
      <div className="min-h-screen flex flex-col justify-center items-center px-4 py-8">
        <h1 className="text-3xl font-semibold mb-12">Create Your Portfolio</h1>
        <form onSubmit={handleSubmit} className="w-full max-w-md">
          <InputField label="Email" name="email" type="email" value={formData.email} readOnly />
          <InputField label="Name" name="name" type="text" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
          <InputField label="Profession" name="profession" type="text" value={formData.profession} onChange={(e) => setFormData({ ...formData, profession: e.target.value })} />
          <InputField label="About Me" name="about" type="textarea" value={formData.about} onChange={(e) => setFormData({ ...formData, about: e.target.value })} />
          <InputField label="Education" name="education" type="text" value={formData.education} onChange={(e) => setFormData({ ...formData, education: e.target.value })} />
          <InputField label="Gpa" name="Gpa" type="text" value={formData.Gpa} onChange={(e) => setFormData({ ...formData, Gpa: e.target.value })} />
          <InputField label="Address" name="address" type="text" value={formData.address} onChange={(e) => setFormData({ ...formData, address: e.target.value })} />
          <InputField label="Contact Number" name="number" type="text" value={formData.number} onChange={(e) => setFormData({ ...formData, number: e.target.value })} />

          {formData.experiences.map((experience, index) => (
            <div key={index}>
              <h2 className="text-xl font-medium text-gray-600">Experience {index + 1}</h2>
              <InputField
                label="Company Name"
                name="companyName"
                type="text"
                value={experience.companyName}
                onChange={(e) => handleChange(e, index, 'experiences')}
              />
              <InputField
                label="Designation"
                name="designation"
                type="text"
                value={experience.designation}
                onChange={(e) => handleChange(e, index, 'experiences')}
              />
              <InputField
                label="Experience Description"
                name="experienceDescription"
                type="textarea"
                value={experience.experienceDescription}
                onChange={(e) => handleChange(e, index, 'experiences')}
              />
              <div className="flex gap-4">
                <DatePicker
                  selected={experience.startDate}
                  onChange={(date) => handleDateChange(date, index, 'experiences', 'startDate')}
                  className="border border-gray-300 w-full p-3 rounded-lg"
                  dateFormat="yyyy-MM-dd"
                  placeholderText="Start Date"
                />
                <label className="flex items-center">
                  Present
                  <input
                    type="checkbox"
                    checked={experience.isPresent}
                    onChange={() => togglePresent(index)}
                  />
                </label>
                {!experience.isPresent && (
                  <DatePicker
                    selected={experience.endDate}
                    onChange={(date) => handleDateChange(date, index, 'experiences', 'endDate')}
                    className="border border-gray-300 w-full p-3 rounded-lg"
                    dateFormat="yyyy-MM-dd"
                    placeholderText="End Date"
                  />
                )}

              </div>

              <button className='mt-5' type="button" onClick={() => removeItem(index, 'experiences')}>
                Remove Experience
              </button>
            </div>
          ))}
          <button className='mb-5' type="button" onClick={() => addMore('experiences')}>
            + Add More Experience
          </button>
          {formData.projects.map((project, index) => (
            <div key={index}>
              <h2 className="text-xl font-medium text-gray-600">Project {index + 1}</h2>
              <InputField
                label="Project Name"
                name="projectName"
                type="text"
                value={project.projectName}
                onChange={(e) => handleChange(e, index, 'projects')}
              />
              <InputField
                label="Description"
                name="description"
                type="textarea"
                value={project.description}
                onChange={(e) => handleChange(e, index, 'projects')}
              />
              <button type="button" onClick={() => removeItem(index, 'projects')}>
                Remove Project
              </button>
            </div>
          ))}
          <button className='mb-5' type="button" onClick={() => addMore('projects')}>
            + Add More Project
          </button>

          <InputField label="Skills" name="skills" type="text" value={formData.skills} onChange={(e) => setFormData({ ...formData, skills: e.target.value })} />
          <button type="submit" className="mt-4 bg-blue-600 text-white rounded-full px-8 py-3 w-full">
            Save
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
}

function InputField({ label, type = "text", name, value, onChange, readOnly }) {
  return (
    <div className="mb-6">
      {label && <label className="block text-xl font-medium text-gray-600 mb-2">{label}</label>}
      {type === "textarea" ? (
        <textarea
          className="border border-gray-300 w-full p-3 rounded-lg"
          name={name}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
        ></textarea>
      ) : (
        <input
          type={type}
          className="border border-gray-300 w-full p-3 rounded-lg"
          name={name}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
        />
      )}
    </div>
  );
}
